import PropTypes from 'prop-types';
import DropDownItem from './DropDownItem';

const InputType = PropTypes.arrayOf(PropTypes.shape({
  type: PropTypes.oneOf(['info', 'buttons', 'destructive']),
  options: PropTypes.arrayOf(
    PropTypes.shape(DropDownItem.propTypes),
  ).isRequired,
}));

export default InputType;



// WEBPACK FOOTER //
// ./src/components/stateful/DropDown/InputType.js